import { z } from "zod";

const getToday = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};

export const createVotingPeriodSchema = z
    .object({
        candidateBookIds: z.array(z.string()).min(2, "Must select at least 2 books"),
        endsAt: z.date({ required_error: "End date is required" }),
        startsAt: z.date({ required_error: "Start date is required" }),
        targetMonth: z.number().int().min(1).max(12),
        targetYear: z.number().int(),
    })
    .refine((data) => data.startsAt && data.endsAt && data.startsAt < data.endsAt, {
        message: "End date must be after start date",
        path: ["endsAt"],
    })
    .refine((data) => data.startsAt && data.startsAt >= getToday(), {
        message: "Start date must not be in the past",
        path: ["startsAt"],
    });

export type CreateVotingPeriodFormData = z.infer<typeof createVotingPeriodSchema>;
